import React from 'react';
import AMenu from 'antd-mobile/lib/menu';



export default class Menu extends AMenu {}